var r=function(r,t){var e=r.slice(0,t);return"string"==typeof r?e+"...":e};export{r as reduceValue};
